export const SUBTYPES = {
  MILEAGE: "Mileage",
  JOB_RELATED: "Job related",
};
